<lib-tour-overview [id]="id"></lib-tour-overview>